<p>
  Navigate to an Algorithm page. Click solve after entering the
  values, on some pages it'll update the solution as you change the
  values using the slider.
</p>
<p>
  Checkout my other
  <a href="https://andinus.unfla.me/projects">projects</a>.
</p>
<p>
  Inspired by Karishma's work:
  <a href="https://karishmarajput.github.io/cg-algo">
    karishmarajput.github.io/cg-algo
  </a>.
</p>
